const initialTop = 17
const step = 8.4

const isValidInEST = (time) => {
    try {
        const [start, end] = time.split("-").map(num => {
            let resp = new Date()
            if (num.match(":")) {
                let parsed = num.split(":").map(tm => parseInt(tm))
                resp.setHours(parsed[0], parsed[1])
                return new Date(resp)
            }
            resp.setHours(parseInt(num), 0)
            return new Date(resp)
        })

        const estTimeNow = (() => {
            let dt = new Date()
            dt.setTime(dt.getTime()+dt.getTimezoneOffset()*60*1000);
            const offset = -300; //Timezone offset for EST in minutes.
            return new Date(dt.getTime() + offset*60*1000);
        })()

        return estTimeNow.getTime() >= start.getTime() && estTimeNow.getTime() <= end.getTime()
    } catch(e) {
        return false
    }
}

export const standardLinks = [{
    width: "6.4%",
    height: "5.7%",
    left: "0.4%",
    top: "0.5%",
    label: "Exit to Lobby",
    href: "/lobby",
    isExternal: true,
},
{
    width: "6.4%",
    height: "5.7%",
    left: "93.3%",
    top: "0.5%",
    label: "Exit to Lobby",
    href: "/lobby",
    isExternal: true,
}]

const linkBuilder = (top, { time, name, clue = null }) => ({
    width: "22.4%",
    height: "7.7%",
    left: "39.3%",
    top: `${top}%`,
    label: isValidInEST(time) ? `Join ${time}` : "unavailable",
    href: isValidInEST(time) ? `/networking-cafe-${name}` : "",
    isExternal: true,
    clue
})

const room = ({ background, name, links = [] }) => ({
    background,
    name: `networking-cafe-${name}`,
    links: [...links, ...standardLinks]
})

const backgrounds = [
    {
        background: "https://assets.swoogo.com/uploads/full/1622285-621e7d4e9bac9.jpg", time: "12-13", name: "one", links: [
            {
                width: "42.5%",
                height: "13.4%",
                left: "28.4%",
                top: `20.6%`,
                href: "",
                onClick: () => { document.getElementById("teams-12-1").click() },
                label: "Tackling Bias through allyship and mentorship"
            },
            {
                width: "42.5%",
                height: "10.8%",
                left: "28.4%",
                top: `34.3%`,
                href: "",
                onClick: () => { document.getElementById("power-of-info").click() },
                label: "Levearing the power of informal networks"
            },
            {
                width: "42.5%",
                height: "10.8%",
                left: "28.4%",
                top: `45.3%`,
                href: "",
                onClick: () => { document.getElementById("allyship").click() },
                label: "The importance of active allyship"
            }
        ]
    },
    {
        background: "https://assets.swoogo.com/uploads/full/1622281-621e7d4dc846f.jpg", time: "13-14", name: "two", links: [
            {
                width: "42.5%",
                height: "10.4%",
                left: "28.4%",
                top: `16.1%`,
                href: "",
                onClick: () => { document.getElementById("teams-1-2").click() },
                label: "Exploring inclusion of transgender and queer identities"
            },
            {
                width: "42.5%",
                height: "10.8%",
                left: "28.4%",
                top: `26.8%`,
                href: "",
                onClick: () => { document.getElementById("beep").click() },
                label: "Real talk with BEEP: Breaking the bias"
            },
            {
                width: "42.5%",
                height: "10.8%",
                left: "28.4%",
                top: `37.9%`,
                href: "",
                onClick: () => { document.getElementById("covid").click() },
                label: "Unpacking the impactos of COVID-19 on women's mental health"
            },
            {
                width: "42.5%",
                height: "10.4%",
                left: "28.4%",
                top: `48.3%`,
                href: "",
                onClick: () => { document.getElementById("bias-market-break").click() },
                label: "Breaking the bias in the market division"
            }
        ]
    },
    {
        background: "https://assets.swoogo.com/uploads/full/1622283-621e7d4e0d767.jpg", time: "14-15", name: "three", links: [
            {
                width: "42.5%",
                height: "12.3%",
                left: "28.4%",
                top: `20.6%`,
                href: "",
                onClick: () => { document.getElementById("building-your-biz").click() },
                label: "Breaking the bias & Building your brand in the discount division"
            },
            {
                width: "42.5%",
                height: "10.3%",
                left: "28.4%",
                top: `33.3%`,
                href: "",
                onClick: () => { document.getElementById("roots").click() },
                label: "Battling cultural bias"
            },
            {
                width: "42.5%",
                height: "11.3%",
                left: "28.4%",
                top: `43.8%`,
                href: "",
                onClick: () => { document.getElementById("spotlight").click() },
                label: "Bias breakers: Women in technology spotlight"
            }
        ]
    },
    {
        background: "https://assets.swoogo.com/uploads/full/1622282-621e7d4dd545a.jpg", time: "15-16", name: "four", links: [
            {
                width: "42.5%",
                height: "10%",
                left: "28.4%",
                top: `19.6%`,
                href: "",
                onClick: () => { document.getElementById("parenting").click() },
                label: "Parenting Beyond the pandemic"
            },
            {
                width: "42.5%",
                height: "10%",
                left: "28.4%",
                top: `30.1%`,
                href: "",
                onClick: () => { document.getElementById("neurodiversity").click() },
                label: "Neurodiversity"
            },
            {
                width: "42.5%",
                height: "10%",
                left: "28.4%",
                top: `40.8%`,
                href: "",
                onClick: () => { document.getElementById("weed").click() },
                label: "Trailblazers in cannabis"
            }
        ]
    },
    {
        background: "https://assets.swoogo.com/uploads/full/1622284-621e7d4e6b02b.jpg", time: "16-17", name: "five", links: [
            {
                width: "42.5%",
                height: "15.3%",
                left: "28.4%",
                top: `20.9%`,
                href: "",
                onClick: () => { document.getElementById("teams-4-5").click() },
                label: "Breaking the bias in your career"
            }
        ]
    }
]

export const homeLinks = backgrounds.map((bg, num) => linkBuilder(initialTop + (step * num), bg))

export const sessions = backgrounds.map((_, id) => room(backgrounds[id]))
